import { Component, OnInit } from '@angular/core';
import { ColDef, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import * as Highcharts from 'highcharts';
import HCMore from 'highcharts/highcharts-more';
import { Router } from '@angular/router';
import { GrievanceDashboardService } from '../grievance-dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';

HCMore(Highcharts);

@Component({
  selector: 'app-grievanceuser2-dashboard',
  templateUrl: './grievanceuser2-dashboard.component.html',
  styleUrls: ['./grievanceuser2-dashboard.component.scss']
})
export class Grievanceuser2DashboardComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;

  chartOptions: Highcharts.Options = {}
  colDefs: ColDef<any>[] = [
    {
      field: 'date',
      headerName: 'Date',
      cellRenderer: (params: any) => {
        return params.value ? params.value.replace('T', ' ') : '';
      }
    },

    {
      field: 'admNO', headerName: 'Student Id ',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'grievanceTrackId', headerName: 'Ticket Id',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'grievanceName', headerName: 'Grievance Type',
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'details', headerName: 'Details',
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'status',
      headerName: 'Status',
      headerStyle: { 'text-align': 'center' },
      cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center' },
      cellRenderer: (params: any) => {
        let color = '';
        let textcolor = '';
        switch (params.value) {
          case 'OPEN':
            color = '#E6F2FF'; // Blue
            textcolor = '#0564B1';
            break;
          case 'RESOLVED':
            color = '#EAFFF3'; // Green
            textcolor = '#039334';
            break;
          case 'IN PROGRESS':
            color = '#FFF3E7'; // Orange
            textcolor = '#FF7E00';
            break;
          case 'ESCALATED':
            color = '#FFF4F1'; // Red
            textcolor = '#FF0000';
            break;
          default:
            color = '#9E9E9E'; // Grey fallback
            textcolor = '#FFFFFF';
        }

        return `
        <button style="
          background-color: ${color};
          color: ${textcolor};
          border: none;
          height:30px;
          display:flex;
          justify-content:center;
          align-items:center;
          border-radius: 2px;
          cursor: default;
          font-size:10px;
          min-width:100px;
          font-weight:600;
        ">
          ${params.value}
        </button>
      `;
      }
    },
    {
      field: 'view', headerName: 'View',
      cellRenderer: (params: any) => {
        return `
              <svg width="29" height="29" viewBox="0 0 29 29"  class="svg"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path id="btn_EYE"
                                              d="M14.4961 13C16.0607 13.0002 17.3299 14.2685 17.3301 15.833C17.3301 17.3977 16.0608 18.6668 14.4961 18.667C12.9314 18.6668 11.6631 17.3977 11.6631 15.833C11.6633 14.2685 12.9315 13.0002 14.4961 13ZM14.4961 14C13.4838 14.0002 12.6633 14.8207 12.6631 15.833C12.6631 16.8454 13.4837 17.6668 14.4961 17.667C15.5085 17.6668 16.3301 16.8454 16.3301 15.833C16.3299 14.8207 15.5084 14.0002 14.4961 14ZM14.4961 10C17.3682 10 19.0143 11.4526 19.9199 12.9014C20.3673 13.6172 20.6343 14.3297 20.7891 14.8604C20.8666 15.1263 20.9161 15.3494 20.9473 15.5078C20.9628 15.5871 20.9744 15.6506 20.9814 15.6953C20.985 15.7176 20.9875 15.7353 20.9893 15.748C20.9902 15.7544 20.9907 15.7598 20.9912 15.7637C20.9915 15.7656 20.992 15.7673 20.9922 15.7686V15.7705L20 15.8955L19.999 15.8877C19.998 15.8803 19.9958 15.8681 19.9932 15.8516C19.9879 15.8182 19.9798 15.7666 19.9668 15.7002C19.9406 15.5671 19.8963 15.3733 19.8281 15.1396C19.6912 14.6704 19.4581 14.0489 19.0723 13.4316C18.3111 12.2139 16.9571 11 14.4961 11C12.0351 11 10.681 12.2139 9.91992 13.4316C9.53412 14.0489 9.30096 14.6704 9.16406 15.1396C9.09592 15.3733 9.05155 15.5671 9.02539 15.7002C9.01234 15.7666 9.00431 15.8182 8.99902 15.8516C8.99641 15.8681 8.99421 15.8803 8.99316 15.8877C8.99264 15.8914 8.99235 15.8943 8.99219 15.8955L8 15.7705V15.7686C8.00016 15.7673 8.00072 15.7656 8.00098 15.7637C8.00149 15.7598 8.00203 15.7544 8.00293 15.748C8.00473 15.7353 8.00722 15.7176 8.01074 15.6953C8.01783 15.6506 8.02934 15.5871 8.04492 15.5078C8.07604 15.3494 8.12556 15.1263 8.20312 14.8604C8.35791 14.3297 8.62487 13.6172 9.07227 12.9014C9.97785 11.4526 11.6239 10 14.4961 10Z"
                                              fill="#777777" class="color_white" />
                                      </svg>
             `;

      },
      cellStyle: { 'cursor': 'pointer', 'text-align': 'center' },

      cellClass: ['color_white'],
      onCellClicked: (params: any) => {
        const Data = params.data;
        // console.log('Data', Data);
        this.service.setData(Data);
        this.service.setView('trackDetailsuser2');
        // Assuming you're inside an Angular Component context
        this.router.navigate(['/trackDetailsuser2']);
      }
    },
  ]
  //row intialization
  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };
  grievanceData: any;
  selectedGrievance: any;

  constructor(private service: GrievanceDashboardService, private router: Router, private spinner: NgxSpinnerService) { }
  quickFilter: string = '';

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }

  ngOnInit(): void {
    this.getCountDetails()

  }
  desiredOrder = ['OPEN', 'RESOLVED', 'IN PROGRESS', 'ESCALATED', 'TOTAL GRIEVANCE'];

  getGrievanceDetails() {
    this.spinner.show();
    this.service.getGrievanceDetails().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        else {
          // console.log(res)
          const customOrder = ['OPEN', 'IN PROGRESS', 'RESOLVED'];

          res = res.sort((a: any, b: any) => {
            return customOrder.indexOf(a.status) - customOrder.indexOf(b.status);
          });
          // console.log(res)
          this.rowData = res;
          this.spinner.hide();

        }
      },
      error: (err: any) => {
        this.spinner.hide();
        console.log(err)
      }
    })
  }
  getCountDetails() {
    this.service.getCountDetails().subscribe({
      next: (res: any) => {
        if (!res) {
          return;
        }
        // console.log(res);
        this.getGrievanceDetails();
        this.grievanceData = res;
        this.grievanceData = this.desiredOrder.map((status: any) =>
          this.grievanceData.find((item: any) => item.statusName.toUpperCase() === status)

        );
        this.barGraph(res)
        this.pieChart(res);
        this.lineGraph()
      },
      error: (err: any) => {
        console.log(err.message)
      }
    })
  }

  pieChart(grievanceData: any) {

    const chartData = grievanceData
      .filter((item: any) => item.statusName !== 'Total Grievance' && item.statusName !== 'ESCALATED')
      .map((item: any) => ({
        name: item.statusName,
        y: item.trackPercentage,
        color: this.getStatusColor(item.statusName)
      }));

    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        height: '200px'
      },
      title: {
        text: '',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>',
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.0f}%',
            distance: 20,
            style: {
              color: '#000',
              fontWeight: 'bold',
            }
          },
          showInLegend: true,
        }
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      series: [{
        type: 'pie',
        name: 'Tickets',
        data: chartData
      }]
    };

    // Then create the chart:
    Highcharts.chart('pieChart', chartOptions);
  }

  getStatusColor(status: string): string {
    switch (status.toUpperCase()) {
      case 'OPEN': return '#1E88E5';
      case 'RESOLVED': return '#43A047';
      case 'IN PROGRESS': return '#FB8C00';
      case 'ESCALATED': return '#E53935';
      default: return '#9E9E9E'; // fallback grey
    }
  }
  getIcon(status: string): string {
    switch (status.toUpperCase()) {
      case 'OPEN': return 'assets/image/grievance/openIcon.svg';
      case 'RESOLVED': return 'assets/image/grievance/resolved.svg';
      case 'IN PROGRESS': return 'assets/image/grievance/inProgressIcon.svg';
      case 'ESCALATED': return 'assets/image/grievance/escalated.svg';
      case 'TOTAL GRIEVANCE': return 'assets/image/grievance/totalGrievance.svg';
      default: return '';
    }
  }

  getBarColor(status: string): string {
    switch (status.toUpperCase()) {
      case 'OPEN': return '#026FD4';
      case 'RESOLVED': return '#0CA766';
      case 'IN PROGRESS': return '#FB9D05';
      case 'ESCALATED': return '#FF333A';
      case 'TOTAL GRIEVANCE': return '#1FA0C9';
      default: return '#D9D9D9';
    }
  }


  barGraph(grievanceData: any) {


    const orderedStatuses = ['OPEN', 'RESOLVED', 'IN PROGRESS', 'ESCALATED'];

    const total = grievanceData.find((d: any) => d.statusName === 'Total Grievance')?.count ?? 1;

    const chartData = orderedStatuses.map(status => {
      const item = grievanceData.find((d: any) => d.statusName === status);
      return {
        name: status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
        y: item?.count ?? 0,
        color:
          status === 'OPEN' ? '#1E88E5' :
            status === 'RESOLVED' ? '#43A047' :
              status === 'IN PROGRESS' ? '#FB8C00' :
                status === 'ESCALATED' ? '#E53935' :
                  undefined
      };
    });

    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'column',
        height: 150,
        backgroundColor: 'transparent'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: orderedStatuses.map(s =>
          s.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
        ),
        lineWidth: 0,
        tickLength: 0,
        labels: {
          style: {
            fontWeight: 'bold',
            color: '#666'
          }
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        gridLineColor: '#eee'
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          const percent = (((this.y ?? 0) / total) * 100).toFixed(2);
          return `<b>Grievance</b><br/><span style="color:${this.color}; font-weight: bold;">${this.key?.toUpperCase()}</span>: ${percent}% of total`;
        }
      },
      plotOptions: {
        column: {
          borderRadius: 5,
          pointPadding: 0.2,
          groupPadding: 0.1,
          dataLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold'
            }
          }
        }
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      series: [{
        type: 'column',
        name: 'Grievances',
        colorByPoint: true,
        data: chartData
      }]
    };

    Highcharts.chart('barGraph', chartOptions);

  }

  lineGraph() {
    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'bubble',
        plotBorderWidth: 1,
        height: 230,
      },
      title: { text: undefined },
      xAxis: {
        title: { text: "Avg-Max-Min" },
        categories: ['0', '0.5', '1'],
        gridLineWidth: 1,
        tickPositions: [0, 1, 2],
      },
      yAxis: {
        title: { text: undefined },
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true,
      },
      series: [
        {
          type: 'bubble',
          name: 'Min',
          showInLegend: false,
          data: [
            { x: 0, y: 4, z: 10 },
            { x: 1, y: 6, z: 10 },
            { x: 2, y: 5, z: 10 },
          ],
          color: '#AA1FC2',
        },
        {
          type: 'bubble',
          name: 'Average',
          showInLegend: false,
          data: [
            { x: 0, y: 5, z: 15 },
            { x: 1, y: 8, z: 15 },
            { x: 2, y: 6, z: 15 },
          ],
          color: '#AA1FC2',
        },
        {
          type: 'bubble',
          name: 'Max',
          showInLegend: false,
          data: [
            { x: 0, y: 6, z: 10 },
            { x: 1, y: 10, z: 10 },
            { x: 2, y: 7, z: 10 },
          ],
          color: '#AA1FC2',
        },
        {
          type: 'line',
          name: 'Vertical line at Line 1',
          showInLegend: false,
          data: [
            { x: 0, y: 4 },
            { x: 0, y: 5 },
            { x: 0, y: 6 },
          ],
          color: '#AA1FC2',
          marker: { enabled: false },
          enableMouseTracking: false,
          lineWidth: 2,
          zIndex: 1,
        },
        {
          type: 'line',
          name: 'Vertical line at Line 2',
          showInLegend: false,
          data: [
            { x: 1, y: 6 },
            { x: 1, y: 8 },
            { x: 1, y: 10 },
          ],
          color: '#AA1FC2',
          marker: { enabled: false },
          enableMouseTracking: false,
          lineWidth: 2,
          zIndex: 1,
        },
        {
          type: 'line',
          name: 'Vertical line at Line 3',
          showInLegend: false,
          data: [
            { x: 2, y: 5 },
            { x: 2, y: 6 },
            { x: 2, y: 7 },
          ],
          color: '#AA1FC2',
          marker: { enabled: false },
          enableMouseTracking: false,
          lineWidth: 2,
          zIndex: 1,
        },
      ],
    };

    Highcharts.chart('lineGraph', chartOptions);

  }



}
